/**
 * Puente entre el snake_case de Postgres y el camelCase de @timecap/core.
 * Aislado aqui para que ni la UI ni el motor tengan que saber del otro.
 */

import type { RawScore, Workout } from '@timecap/core';
import type { ScoreRow, WorkoutSummary } from './api.js';

export function toCoreWorkout(w: WorkoutSummary): Workout {
  return {
    id: w.id,
    eventId: w.event_id,
    name: w.name,
    slug: w.slug,
    sortOrder: w.sort_order,
    scoreType: w.score_type,
    timeCapSeconds: w.time_cap_seconds,
    repTarget: w.rep_target,
    weight: Number(w.weight ?? 1),
    tiebreakEnabled: w.tiebreak_enabled,
    tiebreakLabel: w.tiebreak_label,
    status: w.status,
  };
}

export function toCoreScore(s: ScoreRow): RawScore {
  return {
    id: s.id,
    workoutId: s.workout_id,
    registrationId: s.registration_id,
    status: s.status,
    timeSeconds: s.time_seconds,
    reps: s.reps,
    loadKg: s.load_kg,
    distanceM: s.distance_m,
    capped: s.capped,
    tiebreakSeconds: s.tiebreak_seconds,
    notes: s.notes,
  };
}
